export default function MySQL_NOW() {
  return (
    <div>
      <h2>MySQL_NOW</h2>    </div>
  );
}